import { Paper } from "@mui/material";
import { useEffect, useState } from "react";
import { action, API, controller } from "../../api/api";
import { ToFormData, useFormatPrice } from "../../hooks/Method";
import DonutChart from "../../layout/Chart/DonutChart";

const TopSellingProd = ({ sortDate }) => {
  const formatPrice = useFormatPrice();
  const [topProds, setTopProds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (sortDate.fromDate && sortDate.toDate) {
      setLoading(true);
      API(controller.HomeReport + action.TopSellingProducts).post(
        ToFormData({
          fromDate: new Date(sortDate.fromDate).toISOString(),
          toDate: new Date(sortDate.toDate).toISOString(),
          // Selecting top 5 product
          number: 5,
        }),
        (res) => {
          res && res.status === 200 && setTopProds([...res.result]);
          setLoading(false);
        }
      );
    }
    return () => {};
  }, [sortDate]);

  return !loading ? (
    <Paper className="shadow-xs p-[15px] bg-white">
      {/* Chart */}
      <DonutChart
        name="Top Selling Products"
        labels={[
          ...topProds.map((j) => {
            var name = j.productName;
            if (j.prodType === 2) name += ` (${j.variantName})`;
            name += ` | Qty: ${j.totalQuantitySold} | Amount: ${formatPrice(
              j.totalSalesAmount
            )}`;
            return name;
          }),
        ]}
        series={[...topProds.map((j) => j.totalQuantitySold)]}
      />
    </Paper>
  ) : (
    "Loading..."
  );
};

export default TopSellingProd;
